import PresupuestosGraficoTiempoResolucion from './PresupuestosGraficoTiempoResolucion';

export default PresupuestosGraficoTiempoResolucion;
